import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { handleImageError } from '../../common/utils';
import { ResolutionService } from '../../resolution.service';
import { SubscriptionsService } from '../../../settings/account/subscriptions/subscriptions.service';
import { ModalContentService } from '../../modal-content/modal-content.service';
import { SignalsStoreService } from '../../signals-store.service';
import { Subscription } from '../../../settings/account/subscriptions/subscriptions.types';
import { openModalUnskipProduct } from '../../common/subscriptions.utils';
import { OrderService } from '../../order.service';

@Component({
  selector: 'app-product-main-info',
  imports: [CommonModule],
  templateUrl: './product-main-info.component.html',
  styleUrl: './product-main-info.component.scss'
})
export class ProductMainInfoComponent {

  #resolutionService = inject(ResolutionService);
  #subscriptionsService = inject(SubscriptionsService);
  #modalContentService = inject(ModalContentService);
  #signalsStoreService = inject(SignalsStoreService);
  #orderService = inject(OrderService);
  #router = inject(Router);

  product: InputSignal<any> = input.required();
  subTotalAmount: InputSignal<number> = input.required();
  frequency: InputSignal<string> = input.required();
  deliveryDate: InputSignal<string> = input.required();
  whatsInsideItems: InputSignal<Map<any, any>> = input.required();
  productSubscriptionInfo: InputSignal<Subscription | null> = input.required();
  isSubscriptionSkipped: InputSignal<boolean> = input.required()

  formattedDeliveryDate: Signal<string> = computed(() => this.#setUpDeliveryDate())
  subscriptions: Signal<Subscription[]> = computed(() => this.#signalsStoreService.subscriptions());

  isMobile = computed(() => this.#resolutionService.isMobile());

  handleImageError = handleImageError

  #setUpDeliveryDate() {
    const dd = this.deliveryDate();
    if (!this.isMobile()) return dd;

    const splittedDeliveryDate = dd.split('/');

    return `${splittedDeliveryDate[0]}/${splittedDeliveryDate[1]}`;
  }

  openModalUnskipProduct() {
    openModalUnskipProduct({
      sub: this.productSubscriptionInfo()!,
      modalContentService: this.#modalContentService,
      subscriptionsService: this.#subscriptionsService,
      orderService: this.#orderService,
      router: this.#router,
      goToCustomizeBundle: false
    })
  }

}
